import DataModel from '../../common/model/DataModel';

export default class ScheduleDateRangeDataModel extends DataModel {
  constructor() {
    super();

    this.popupSessionId = crypto.randomUUID();
    this.popupTitle = '';
    this.popupVisible = false;
    this.availableContracts = [];
    this.selectedContracts = [];
    this.rangeFirstDate = null;
    this.rangeLastDate = null;
    this.submitPrinceTrades = false;
    this.submitSata = false;
    this.requireSubmissionType = false;
    this.commandType = null;
    this.commandLabel = '';
    this.commandIcon = null;

    this.isEditingEnabled = false;
  }
}